export default "__VITE_ASSET__0918694a__"